export enum MerchantRole {
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
  DRIVER = "DRIVER",
}

export interface NewMerchantMember extends MerchantMember {
  role: MerchantRole;
}

export interface MerchantMemberBodyRequest {
  email: string;
  phone: number;
  merchant_stores_ids: string[];
  phoneCode: string;
  role: MerchantRole;
}
